var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_5877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8419 8.18392C15.8419 7.64011 15.7978 7.09335 15.7037 6.55835H8.15784V9.639H12.479C12.2997 10.6326 11.7235 11.5115 10.8799 12.07V14.0689H13.4579C14.9717 12.6756 15.8419 10.6179 15.8419 8.18392Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15816 16.0001C10.3158 16.0001 12.1354 15.2917 13.4611 14.0688L10.8831 12.0699C10.1659 12.5579 9.23991 12.8342 8.1611 12.8342C6.07401 12.8342 4.3044 11.4262 3.66945 9.53308H1.00916V11.5937C2.36723 14.2952 5.13335 16.0001 8.15816 16.0001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.66644 9.53337C3.33133 8.5398 3.33133 7.46393 3.66644 6.47036V4.40973H1.00908C-0.125586 6.67025 -0.125586 9.33348 1.00908 11.594L3.66644 9.53337Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.15815 3.16632C9.2987 3.14868 10.401 3.57786 11.227 4.36566L13.5111 2.08162C12.0648 0.723548 10.1453 -0.0230994 8.15815 0.00041704C5.13335 0.00041704 2.36723 1.70536 1.00916 4.40975L3.66651 6.47038C4.29852 4.57437 6.07107 3.16632 8.15815 3.16632Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_5877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmb);
export default __webpack_public_path__ + "static/media/gmb.46ade51deb5b717e4acc72c93e8f593d.svg";
export { ForwardRef as ReactComponent };